import React, { useEffect, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import { checkConnection } from '../lib/supabase';

const { FiDatabase, FiCheckCircle, FiAlertCircle } = FiIcons;

const DBStatus = () => {
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    checkConnection().then(isConnected => {
      setStatus(isConnected ? 'connected' : 'disconnected');
    });
  }, []);

  if (status === 'checking') return null;

  return (
    <div className={`fixed bottom-4 right-4 px-4 py-2 rounded-full flex items-center gap-2 text-sm font-medium shadow-lg backdrop-blur-sm z-50 ${
      status === 'connected' 
        ? 'bg-emerald-500/10 text-emerald-600 border border-emerald-500/20' 
        : 'bg-red-500/10 text-red-600 border border-red-500/20'
    }`}>
      <FiDatabase className="text-lg" />
      <span>{status === 'connected' ? 'Supabase Connected' : 'DB Disconnected'}</span>
      {status === 'connected' ? <FiCheckCircle /> : <FiAlertCircle />}
    </div>
  );
};

export default DBStatus;